import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "highcharts/modules/no-data-to-display";
import { useGetDashboardCardBoardPieCricleData } from "features/dashboard/use-cases/get-dashboard-cricle";
import { useUserContext } from "features/users";

// ✅ Initialize the module

export const RepeatParticipationView = ({
  dateRange,
  selectedYear,
  selectedEvent,
  selectedCategory,
}: any) => {
        const { user } = useUserContext()
  
  const { data: repeatData } = useGetDashboardCardBoardPieCricleData({
    Flag: "repeatparticipation",
    FromDate: dateRange?.[0]?.format("YYYY-MM-DD") || "",
    ToDate: dateRange?.[1]?.format("YYYY-MM-DD") || "",
    Year: selectedYear || "",
    EventId: selectedEvent || "",
    CategoryId: selectedCategory || "",
        AgentId: user?.user_id
    
  });

  const repeat = repeatData?.RepeatParticipation || {};
  const firstTime = repeat?.UniqueIDsCount || 0;
  const repeated = repeat?.RepeatIdsCount || 0;

  const hasData = firstTime > 0 || repeated > 0;

  const chartData = hasData
    ? [
        { name: "First Time", y: firstTime },
        { name: "Repeated", y: repeated },
      ]
    : [];

  const options: Highcharts.Options = {
    chart: {
      type: "pie",
    },
    title: {
      text: "Repeat Participation",
    },
    tooltip: {
      pointFormat: "<b>{point.percentage:.1f}%</b>",
    },
    credits: {
      enabled: false,
    },
    lang: {
      noData: "No data found", // ✅ Text inside chart when empty
    },
    noData: {
      style: {
        fontWeight: "bold",
        fontSize: "14px",
        color: "#666",
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b>: {point.percentage:.1f} %",
        },
      },
    },
    colors: ["#FFD700", "#007BFF"], // Yellow = First Time, Blue = Repeated
    series: [
      {
        name: "Participants",
        type: "pie",
        data: chartData,
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
